import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = []
  static outlets = ['form']
  static values = {
    fieldType: String,
  }

  initialize() {
    this.EMAIL_INVALID_MESSAGE = 'Voer een geldig e-mailadres in.'
    this.DATE_INVALID_MESSAGE = 'Voer een geldige datum in.'
    this.REQUIRED_INVALID_MESSAGE = 'Dit is een verplicht veld.'
    this.element['controller'] = this
    this.fieldNotOk = true
  }
  connect() {
    this.element['controller'] = this
    this.element.dataset.validationResult = ''
    this.input = Array.from(
      this.element.querySelectorAll(
        'input[type="radio"], input[type="checkbox"], input[type="text"], input[type="email"], input[type="number"], textarea, select'
      )
    )
    this.wrapper = this.element.querySelector('.input-field')
    this.isRequired = this.wrapper.classList.contains('required')
    this.helperTextElem = this.element.querySelector('.helper-text')
    this.label = this.element.querySelector('label')
    this.input.map((elem) => {
      elem.addEventListener('focus', () => {
        this.activateInput()
      })
    })
    this.input.map((elem) => {
      elem.addEventListener('blur', () => {
        this.activateInput()
        this.validate()
      })
    })
    this.input.map((elem) => {
      const eventType = elem.nodeName === 'SELECT' ? 'change' : 'input'
      elem.addEventListener(eventType, (e) => {
        e.target.dataset.isTouched = true
        this.validate()
      })
    })
    setTimeout(() => {
      this.validate()
      this.activateInput()
    }, 1)
  }
  validateEmail = (email) => {
    return !!String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }
  validateDate = (day, month, year) => {
    if (!day || !month || !year) {
      return false
    }
    const daysInMonth = (month, year) => {
      return new Date(year, month, 0).getDate()
    }
    const daysInThisMonth = daysInMonth(parseInt(month), parseInt(year))
    return daysInThisMonth >= parseInt(day)
  }
  inputHasValue(input) {
    return ['checkbox', 'radio'].includes(input.type)
      ? input.checked
      : input?.value || input?.value.trim() || input?.value.trim().length
  }
  hasFocus() {
    return !!this.input.filter((elem) => document.activeElement === elem).length
  }
  hasValue() {
    return !!this.input.filter((elem) => !!this.inputHasValue(elem)).length
  }
  activateInput() {
    this.label?.classList[this.hasFocus() || this.hasValue() ? 'add' : 'remove']('active')
    this.wrapper?.classList[this.hasFocus() || this.hasValue() ? 'add' : 'remove']('active')
  }
  validate() {
    const allValues = this.input.map((elem) => elem.value)
    const allCheckboxesHasValue = this.input
      .map((elem) => elem.checked)
      .filter((checked) => checked)
    const allStates = this.input.map((elem) => {
      let states = {}
      const isRadio = elem.type === 'radio'
      const isCheckboxMultiple = this.fieldTypeValue === 'checkboxselectmultiple'
      const hasInput = !isCheckboxMultiple ? this.inputHasValue(elem) : allCheckboxesHasValue.length
      const isTouched = elem.dataset.isTouched || hasInput
      const isRequired = isRadio ? elem.hasAttribute('required') : this.isRequired
      const isEmail = elem.type === 'email'
      const isDate = this.fieldTypeValue === 'selectdatewidget'
      const emailIsValid = hasInput ? this.validateEmail(elem.value) : !isRequired
      const dateIsValid = allValues.filter((v) => v != '').length
        ? this.validateDate(...allValues)
        : !this.isRequired
      const requiredIsValid = isRequired ? hasInput : true
      const isValid = isEmail ? emailIsValid : isDate ? dateIsValid : requiredIsValid
      const invalidMessage = isEmail
        ? this.EMAIL_INVALID_MESSAGE
        : isDate
        ? this.DATE_INVALID_MESSAGE
        : this.REQUIRED_INVALID_MESSAGE
      states.error = isValid ? false : invalidMessage
      states.touched = isTouched
      states.hasInput = hasInput
      return states
    })
    const isTouched = allStates.filter((states) => states.touched).length
    const hasInput = allStates.filter((states) => states.hasInput).length
    let allErrors = [...new Set(allStates.map((states) => states.error).filter((e) => !!e))]

    this.helperTextElem.dataset.error = allErrors.length ? allErrors.join(', ') : ''

    if (hasInput || isTouched) {
      this.element.dataset.validationResult = allErrors.length
        ? `${this.label.textContent.replace('*', '')}: ${allErrors.join(', ')}`
        : ''
      this.wrapper?.classList.remove('valid', 'errors')
      this.wrapper?.classList.add('touched')
      this.wrapper?.classList[isTouched ? 'add' : 'remove']('validated')
      this.wrapper?.classList.add(allErrors.length && (hasInput || isTouched) ? 'errors' : 'valid')
    }
    this.fieldNotOk = isTouched ? allErrors.length : this.isRequired && !hasInput

    if (this.hasFormOutlet) {
      this.formOutlet.fieldValidated()
    }
  }
}
